<template>
  <div class="container">
    <div class="mt-3">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="row">
          <div v-for="(info, index) in mediaArray" :key="index" class="col-lg-2 col-md-4 col-sm-6 ">
            <div class="d-flex flex-column align-items-start justify-content-start mt-4"
                 style="flex-wrap: wrap; align-content: center">
              <input :id="'checkbox-' + index" v-model="selectedMedia"
                     :disabled="allowPdfSelect != null? !allowPdfSelect : info.media_file_type !== 'image'"
                     :value="info.media_file_id" class="checkbox-input" style="margin-inline: 8px;"
                     type="checkbox"
                     @change="selectMedia">
              <label :for="'checkbox-' + index" class="checkbox-label">
                <template v-if="info.media_file_type === 'image'">
                  <img :src="info.show_file_path" alt="media" class="img-thumbnail"
                       style="display:flex;justify-content: center;align-items: center;
                       padding: 8px;margin: 8px; width:120px; height: 120px; background-color: rgb(244, 245, 245);
                       border-radius: 6px;"
                       @error="handleImageError">
                </template>

                <template v-else-if="info.media_file_type === 'pdf'">
                  <div class="rounded border"
                       style="text-align: center; height: 120px;width: 120px;
                       background-color: white; margin-left: 8px;margin-top: 8px;padding-top: 20px; padding-left: 15px;padding-right: 15px;">
                    <img alt="" src="@/assets/img/pdf_icon.svg" style="height: 40px; width: 40px; ">
                    <div class="titleText" style="overflow: hidden; word-wrap: break-word; ">
                      {{ info.media_file_name }}
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div
                      class="border rounded"
                      style="text-align: center;height: 120px;width: 120px; padding: 8px;margin: 8PX; border: 1px solid gray;">
                    <img alt="" src="@/assets/unknown.png" style="height: 40px; width: 40px;">
                    <div class="titleText" style="overflow: hidden; word-wrap: break-word; ">
                      {{ info.media_file_name }}
                    </div>
                  </div>

                </template>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaService from "@/services/media.service";
import Config from '@/config/index.js';
// import UploadMedia from './UploadMedia.vue';
export default {
  name: 'selectableMedia',
  components: {
    // UploadMedia,
  },
  props: ['fetchImageIds', 'dontShowImage', 'allowPdfSelect', 'showOnlyImage'],

  data() {
    return {
      mediaArray: [],
      selectedMedia: [],
      imageList: [],
      isAllSelected: false,
    };
  },
  mounted() {
    this.fetchMedia();
    this.selectedMedia = this.fetchImageIds != null ? this.fetchImageIds : [];
  },
  methods: {
    handleImageError(event) {
      // Update the image source to the dummy image when an error occurs
      event.target.src = "https://demofree.sirv.com/nope-not-here.jpg";
    },
    async fetchMedia() {
      this.mediaArray = [];
      this.selectedMedia = [];
      let response = await MediaService.getAllMedia();
      if (this.dontShowImage) {
        response.data = response.data.filter(item => item.media_file_type !== "image")
      } else if (this.showOnlyImage) {
        response.data = response.data.filter(item => item.media_file_type === "image")
      }
      if (this.fetchImageIds) {
        const matchingObjects = response.data.filter(item => this.fetchImageIds.includes(item.media_file_id));
        const nonMatchingObjects = response.data.filter(item => !this.fetchImageIds.includes(item.media_file_id));
        response.data = [...matchingObjects, ...nonMatchingObjects]
      }
      this.mediaArray = response.data;
      //iterate through the array and add the file path
      this.mediaArray.forEach(element => {
        // element.show_file_path = Config.apiFileBasePath + element.file_path;
        element.show_file_path = Config.apiFileBasePath + '/thumbnail' + element.thumbnail_file_path;
      });
    },

    sendToPage(data) {
      this.$emit('imgList', data);
    },
    async selectMedia() {
      this.imageList = [];
      this.selectedMedia.forEach((item) => {
        this.imageList.push(this.mediaArray.filter((media) => media.media_file_id === item));
      });

      //store the imageList in local storage
      // localStorage.setItem('imageList', JSON.stringify(this.imageList));
      this.sendToPage(JSON.stringify(this.imageList));

    },
  }


}
</script>
<style scoped>
.titleText {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  font-size: 12px;
  /* number of lines to show */
  line-clamp: 3;
  line-height: 17px;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>
